// src/pages/MPFlow/components/targeting/AgeRangeSlider.jsx
import React from 'react';

export default function AgeRangeSlider({ min = 18, max = 65, onChange }) {
  const handleMin = (e) => {
    const v = Math.min(Number(e.target.value), max - 1);
    onChange({ age_min: v, age_max: max });
  };
  const handleMax = (e) => {
    const v = Math.max(Number(e.target.value), min + 1);
    onChange({ age_min: min, age_max: v });
  };

  const pctMin = ((min - 13) / (65 - 13)) * 100;
  const pctMax = ((max - 13) / (65 - 13)) * 100;

  return (
    <div className="seg-age">
      <div className="seg-age__labels">
        <span className="seg-age__val">{min} anos</span>
        <span className="seg-age__val">{max === 65 ? '65+' : `${max} anos`}</span>
      </div>
      <div className="seg-age__track">
        <div className="seg-age__fill" style={{ left: `${pctMin}%`, width: `${pctMax - pctMin}%` }} />
        <input
          type="range" min={13} max={65} value={min}
          onChange={handleMin}
          className="seg-age__input seg-age__input--min"
        />
        <input
          type="range" min={13} max={65} value={max}
          onChange={handleMax}
          className="seg-age__input seg-age__input--max"
        />
      </div>
    </div>
  );
}
